import api from "@/services/api";
import get from "lodash/get"

export function userId(state) {
    return state.user && state.user.id
}

export function isAthlete(state) {
    return state.user && state.user.type === 'athletes'
}

export function isClubStaff(state) {
    return state.user && state.user.type === 'clubStaffs'
}

export function isCollegeCoach(state) {
    return state.user && state.user.type === 'coaches'
}

export function isLoggedOut(state) {
    return state.isRetrieved && !state.user
}

export const authUsingProfileKey = state => state.isRetrieved && (state.user?.usingProfileKey ?? false);

export function isLoggedIn(state) {
    return !!state.user
}

/* API Getters */
export function isFree() {
    return api.clientData('user_type') == 6
}

export function isPaid() {
    return api.clientData('user_type') == 1
}

export function isPlayer() {
    let userType = api.clientData('user_type');
    return userType == 1 || userType == 6
}

export function isExpired() {
    return !!api.clientData('user_is_expired')
}

export function isIdentityVerified() {
    return !!api.clientData('is_identity_verified');
}
/* /Api Getters */

export const firstName = state => state.user.firstName
export const lastName = state => state.user.lastName
export const sport = state => get(state.user, 'sport')
export const organization = state => state.user.organization

// Get a list of all the organizations we're on,
// whether we're a staff (one org) or an athlete (many orgs).
export const organizations = state => {
    if (state.user.clubAffiliations || state.user.highSchoolAffiliations) {
        return [
            ...state.user.clubAffiliations || [],
            ...state.user.highSchoolAffiliations || [],
        ].map(aff => aff.organization)
    } else if (state.user.organization) {
        return [state.user.organization]
    } else {
        return []
    }
}

export const isAdmin = state => state.user.isAdmin
export const teamAffiliations = state => state.user.teamAffiliations

export const relevantGender = (state, getters, rootState, rootGetters) => (getters.isAthlete ? state.user.gender :
    getters.isClubStaff ? state.user.organization.gender :
    getters.isCollegeCoach ? state.user.program.gender :
    null)

export function isUsingProfileKey(state, getters) {
    const params = new URLSearchParams(window.location.search)
    return params.has('k')
}

export function getUserSport(state) {
    return state.user.sport.name
}